import type { GetLayoutShapeId } from "./types";

export const getLayoutShapeId: GetLayoutShapeId = ({ kind, id }) =>
  `${kind}-${id}`;
